export const features = [
  {
    featureName: 'ai-prompt',
    expirationDate: '2025-03-01',
    tooltip: 'Here\'s some info about this new feature'
  }
]
